const AboutList = [
    
    {
        title: `Tech Skills`,
        items: [
            `HTML`,
            `CSS`,
            `JavaScript`,
            `React`,
            `GitHub`,
            `PHP`
        ]
    },
    {
        title: `Soft Skills`,
        items: [
            `Communication`,
            `Problem Solving`,
            `Creativity`,
            `Adaptability`,
            `Learner`
        ]
    },
]

export default AboutList;